
        import 'Scratch.6eb7f49.css-module'
        export default {"Tabs":"Tabs_Scratch_6eb7f49"}
    